// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2r2AP","Icon":"Languages_Icon__2_d2R","LanguagesSelect":"Languages_LanguagesSelect__2DPRx","minimalist":"Languages_minimalist__1rOlc"};